




































































































import { setup } from "../../../../utils/devicePlatform";
export default {
  name: "patientTemplate-login-h5",
  data() {
    return {
      checkedPolicy: false,
      isShowAd: true,
      isShowPhoneLogin: true,
      platform: "h5", // "h5" | "android" | "ios" | "pc" | "weixin" | "weibo" | "alipay" | "hapApp"
      device: "browser", // "browser" | "app";
      weixinResult: "",
      loginForm: {
        // 登录表单
        phone: "",
        sms: "",
      },
      formState: {
        // 表单状态
        loading: false,
        disabled: true,
      },
      sms: {
        text: "获取验证码",
        countTime: 60,
        disabled: false,
      },
      styleVar: {
        "--space": "8vw",
        "--logo": "5.333vw",
      },
    };
  },
  created() {
    const platformMes = setup();
    (this as any).platform = platformMes.platform;
    (this as any).device = platformMes.device;
  },
  methods: {
    handleCheckPolicy() {
      (this as any).checkedPolicy = !(this as any).checkedPolicy;
    },
    handleFocus() {
      (this as any).styleVar["--space"] = "4vw";
      (this as any).styleVar["--logo"] = "1.333vw";
    },
    handleBlur() {
      (this as any).styleVar["--space"] = "8vw";
      (this as any).styleVar["--logo"] = "5.333vw";
    },
    handleWxLogin() {
      console.log(0);
    },
    handleWeiboLogin() {
      console.log(0);
    },
    generateCode() {
      console.log(0);
    },
    handleGetSmsCode() {
      console.log(0);
    },
    handleLogin() {
      console.log(0);
    },
    handleDownloadApp() {
      console.log(0);
    },
    handleCloseAd() {
      console.log(0);
    },
  },
};
